import { asyncSuccess, asyncFailure } from "utils"

export const initiateVisaModuleForAgency = ({ data, ...options }) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-api-key": VISAERO_X_API_KEY_AGENT_MODULE,
    },
    body: JSON.stringify(data),
    ...options,
  }

  return fetch(VISAERO_AGENT_MODULE_API, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}
